import { createBrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import App from "../../App";
import Login from "../../pages/login/Login";
import PublicRoute from "../PublicRoute";
import Animations from "../../components/animation/Animation";

const rotaLogin = createBrowserRouter([
    {
        id: 'app-login',
        path: '/login',
        element: <App />,
        children: [
            {
                path: '',
                element: (
                    <Suspense fallback={<Animations />}>
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    </Suspense>
                )
            }
        ]

    }
]);

export default rotaLogin;